import React from "react";

import { DAILY_PRIZES } from "../utils/dailyPrizes";
import { useIsMobile } from "../../../../../device/selectors";

const MareaExtragereTab = () => {
  const isMobile = useIsMobile();
  return (
    <div className={"font-jost pb-8"}>
      {/*info*/}
      <div className={"text-center"}>
        <div className={"uppercase text-dark-1 font-bold text-lg leading-6 mb-6 lg:text-xl lg:leading-6.5"}>
          Daily draw
        </div>
        <div className={"mb-6 text-sm lg:text-base text-gray-1 leading-5 lg:leading-5.5 font-normal"}>
          Over <strong className={"text-dark-1 font-semibold"}>£17,000 in prizes</strong> must be won tonight. Secure
          your tickets now to be one of our 6,000 daily winners.
          {/* Over £10,000 in prizes must be won tonight. Secure your tickets now to be one of our 5,000 daily winners. */}
        </div>
      </div>

      {/*grid*/}
      <div className={""}>
        <div className="relative min-h-fit grid grid-cols-2 gap-3 max-lg:max-w-[256px] max-lg:mx-auto lg:grid-cols-3">
          {DAILY_PRIZES.map((prize, id) => (
            <div
              className={
                "rounded-lg bg-white relative overflow-hidden flex-center flex-col text-center px-2 py-2 gap-2 shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)] "
              }
              key={id}>
              <div>
                <div
                  className={
                    "text-base lg:text-xl font-bold leading-5.5 lg:leading-6.5 mb-0.5 bg-gradient-botb bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
                  }>
                  {prize.count}x
                </div>
                <div
                  className={
                    "text-gray-1 text-xs lg:text-base font-medium leading-4 lg:leading-5.5 min-h-8 lg:min-h-11"
                  }>
                  {prize.prize}
                </div>
              </div>
              <div className={"mt-auto h-[65px] w-full flex-center lg:h-[94px]"}>
                {/*TODO - add correct&dynamic img path*/}
                <img
                  width={98}
                  height={65}
                  className={"w-full h-auto"}
                  src={
                    `/assets/images/christmas-raffle/daily-prizes/${prize.imgId}.png`
                    // prizeLogos[
                    //   prize.imgId.split(" ").join("").toLocaleLowerCase()
                    // ]
                  }
                />
              </div>
              <div className="size-40 -left-20 -top-[90px] lg:-top-[100px] absolute bg-[#EDF1FF] rounded-full blur-[80px] z-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MareaExtragereTab;
